nextPl